import React, { useState } from "react";
import { VirtuosoGrid } from "react-virtuoso";
import {
  addParamsURL,
  downloadFile,
  getFileNameFromDisposition,
  replaceMultipleSpaces,
} from "../../util/helper";
import decryptUrl from "../../util/img-decryption";
import Loader from "../UI/Loader/Loader";
import { AvatarV2, Button, Icon, Notifications } from "@jds/core";
import { Box, Checkbox, Skeleton } from "@mui/material";

import brokenImg from "../../assets/png/brokenImg.png";

import classes from "./GridGallery.module.css";
import useApiHttp from "../../hooks/use-http";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  openFileSideBar,
  setFileDetails,
} from "../../store/state-slices/fileDetailsSidebar";

const gridComponents = {
  Item: ({ children, ...props }) => (
    <div {...props} className={`${classes["grid-item"]}`}>
      {children}
    </div>
  ),
  List: React.forwardRef(({ style, children }, ref) => (
    <div ref={ref} className={`${classes["grid-list"]}`} style={style}>
      {children}
    </div>
  )),
};
/* ===============================
   IMAGE ITEM COMPONENT
   =============================== */
function ImageItem({
  img,
  onCheckBoxClick,
  isActive,
  index,
  isPublic,
  isAdmin,
  selectedTab,
  onClick = () => { },
  selectedId = [],
}) {
  const eventFID = localStorage.getItem("eventFID");
  const { fid: folderId, id: eventId } = useParams();
  const [errorImg, setErrorImg] = useState(false);
  const [loadingImg, setLoadingImg] = useState(true);
  const thumbnailUrl = addParamsURL(decryptUrl(img.thumbnailFileSignedPath), {
    size: "s",
    imgType: "webp",
  });
  const dispatch = useDispatch();
  const handleCardClick = () => {
    if (selectedId.length > 0) {
      onCheckBoxClick(!isActive, index, img.id);
    } else {
      onClick(index + 1);
    }
  };

  const { sendRequest: thumbnailRequest, isLoading: isThumbnailRequest } =
    useApiHttp();
  const { sendRequest: downloadRequest } = useApiHttp();

  const downloadHande = (mediaId) => {
    downloadRequest(
      {
        url: `organizer/download`,
        method: "POST",
        base: "MEDIA",
        // formData: true,
        body: {
          mediaId,
          eventId,
        },
      },
      null,
      (data, res) => {
        const imageUrl = URL.createObjectURL(data);
        const fileName = getFileNameFromDisposition(res);
        downloadFile(imageUrl, fileName);
      },
      (err, data) => {
        Notifications.toast.error({
          id: "download-photos-error",
          title: data?.message,
        });
      },
    );
  };

  const thumbnailUpdate = (thumbnail) => {
    thumbnailRequest(
      {
        url: `event/update-thumbnail`,
        method: "PUT",
        body: {
          eventId,
          folderId: eventFID,
          thumbnail,
        },
        // formData: true,
      },
      null,
      (data) => {
        Notifications.toast.success({
          id: "upload-thumbnail",
          title: data?.message,
        });
      },
      (err, data) => {
        Notifications.toast.error({
          id: "upload-thumbnail",
          title: data?.message,
        });
      },
    );
  };

  return (
    <div
      className={`${classes["image-card"]}`}
      onClick={handleCardClick}
      key={index}
    >
      {/* Avatar */}

      {/* {loadingImg && (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          className="image-skeleton"
        />
      )} */}

      {/* Image */}
      <img
        src={errorImg ? brokenImg : thumbnailUrl}
        alt=""
        loading="lazy"
        onLoad={() => {
          console.log("Helllo==>loading");
          setLoadingImg(false);
        }}
        onError={() => {
          setErrorImg(true);

          setLoadingImg(false);
        }}
      />

      {/* Hover Overlay */}
      <div
        className={`${classes["hover-overlay"]} ${isActive || selectedId.length > 0 ? classes["hover-overlay-active"] : ""} ${selectedId.length > 0 ? classes["check-box-active"] : ""}`}
      >
        <div className={`${classes["hover-header"]}`}>
          <div />
          {selectedTab !== "approvedPhotosAsPhotographer" && (
            <div className={`${classes["header-options"]}`}>
              <Box
                className={`${classes["view-button"]}`}
                sx={{
                  "--color-primary-grey-60": "white",
                }}
                title="View"
                onClick={(e) => {
                  e.stopPropagation();
                  onClick(index + 1);
                }}
              >
                <Icon ic={"IcZoomIn"} color="grey-60" size="m" />
              </Box>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <Checkbox
                  size="small"
                  checked={isActive}
                  onChange={(e) =>
                    onCheckBoxClick(e.target.checked, index, img.id)
                  }
                  sx={{
                    color: "white",
                    "&.Mui-checked": {
                      color: "white",
                    },
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={`${classes["bottom-bar"]}`}>
        <div className={`${classes["photo-details"]}`}>
          <span title={img.fileName}>{img.fileName}</span>
          <span title={img.userName}>~ {img.userName}</span>
        </div>

        <div className={`${classes["photo-actions"]}`}>
          {isAdmin && (
            <Box
              sx={{
                "--color-primary-grey-60": "white",
              }}
              title="Download"
              onClick={(e) => {
                e.stopPropagation();
                downloadHande(img.id);
              }}
            >
              <Icon ic={"IcDownload"} color="grey-60" size="m" />
            </Box>
          )}
          {isAdmin && selectedTab !== "photographersUploadedPhotos" && (
            <Box
              sx={{
                "--color-primary-grey-60": "white",
              }}
              title="Set Thumbnail"
              onClick={(e) => {
                e.stopPropagation();
                thumbnailUpdate(decryptUrl(img.reducedFileSignedPath));
              }}
            >
              <Icon ic={"IcScanPicture"} color="grey-60" size="m" />
            </Box>
          )}
          {isAdmin && (
            <Box
              sx={{
                "--color-primary-grey-60": "white",
              }}
              title="Image info"
              onClick={(e) => {
                e.stopPropagation();
                dispatch(setFileDetails(img));
                dispatch(openFileSideBar());
              }}
            >
              <Icon ic={"IcInfo"} color="grey-60" size="m" />
            </Box>
          )}
          {/* <Box
            sx={{
              "--color-primary-grey-60": "white",
            }}
          >
            <Icon ic={"IcTrash"} color="grey-60" size="m" />
          </Box> */}
        </div>
      </div>
    </div>
  );
}
const MemoImageItem = React.memo(ImageItem);
/* ===============================
   MAIN GRID COMPONENT
   =============================== */
export default function GridGallery({
  images = [],
  endReached = () => { },
  onCheckBoxChange = () => { },
  onClick = () => { },
  loading = false,
  selectedId = [],
  isAdmin = false,
  selectedTab,
}) {
  const handleSetThumbnail = (img) => {
    console.log("Thumbnail set for:", img);
  };

  return (
    <div className={`${classes["grid-container"]}`}>
      <VirtuosoGrid
        totalCount={images.length}
        endReached={endReached}
        className="custom-scrollbar"
        overscan={200}
        components={{ ...gridComponents, Footer: loading ? Footer : null }}
        itemContent={(index, item) => (
          <ImageItem
            key={index}
            img={images[index]}
            index={index}
            onCheckBoxClick={onCheckBoxChange}
            onSetThumbnail={handleSetThumbnail}
            isActive={selectedId.includes(images[index].id)}
            isAdmin={isAdmin}
            selectedTab={selectedTab}
            isPublic={images[index].isPublic}
            onClick={onClick}
            selectedId={selectedId}
          />
        )}
      />
    </div>
  );
}

/* ===============================
   FOOTER LOADER
   =============================== */
const Footer = () => (
  <Loader size="small" containerProps={{ style: { marginTop: 16 } }} />
);
